export enum CookieStatistics {
  Show = 'show',
  Settings = 'settings',
  All = 'all',
  AdvertisingOnly = 'advertisingOnly',
  AnalyticsOnly = 'analyticsOnly',
  None = 'none',
  Error = 'error',
  Dismiss = 'dismiss',
  Leave = 'leave',
}
